import { $authHost } from ".."

export const getUnitMeasuresAPI = async () => {
    const {data} = await $authHost.get(`api/unit_measures/`)
    return data
}

export const getUnitMeasureOptionsAPI = async () => {
    const {data} = await $authHost.get(`api/unit_measures/options`)
    return data
}